import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: 'Do you offer delivery?',
    answer: 'Yes! We offer free local delivery on eligible orders over $100 within 5km of your nearest store. Order by 4pm for next-day delivery. For further distances or regional WA, contact your local store to arrange postage.'
  }, {
    question: 'Can I pick up my order the same day?',
    answer: 'Yes! Order online before 2pm for same-day Click and Collect. Your order will typically be ready in as little as 2 hours at your preferred location.'
  }, {
    question: 'What is your returns policy?',
    answer: 'We offer a 30-day 100% satisfaction guarantee. If you or your pet are not completely happy with a product, return it within 30 days for a full refund or exchange. No questions asked.'
  }, {
    question: 'Do you price match?',
    answer: 'Yes! We price-check against major competitors to ensure you get the best value. If you find an identical stocked item cheaper locally, let us know and we will match it.'
  }, {
    question: 'How do I choose my local store?',
    answer: 'Use our store selector at the top of the page to pick your nearest Better Pets and Gardens location. You can also browse all six stores on our Stores page.'
  }, {
    question: 'Can I check if a product is available at my store?',
    answer: "You can enquire about product availability by clicking 'Check Store Availability' on any product page, or by calling your local store directly."
  }, {
    question: 'How does the Customer Care Club work?',
    answer: 'It is free to join! Earn points on every purchase, save $10 on big bags of premium pet food, and receive members-only specials. No card needed — just your phone number at checkout.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="section-padding bg-warm-50" data-id="element-99">
      <div className="container-wide max-w-4xl" data-id="element-100">
        <div className="text-center mb-10" data-id="element-101">
          <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-gray-900 mb-4" data-id="element-102">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600" data-id="element-103">
            Got a question? We are here to help.
          </p>
        </div>

        <div className="space-y-4" data-id="element-104">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className={`border rounded-2xl overflow-hidden transition-all duration-300 ${isOpen ? 'border-brand-blue shadow-soft' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-105">
                <button className="w-full px-6 py-5 flex items-center justify-between text-left bg-white focus:outline-none active:scale-[0.99]" onClick={() => toggleFaq(index)} data-id="element-106">
                  <span className="font-heading font-bold text-lg text-gray-900 pr-8" data-id="element-107">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-brand-blue flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-108" />
                </button>

                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-109">
                  <p className="text-gray-600 leading-relaxed" data-id="element-110">{faq.answer}</p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}